/** OAuth authorize query params (UI only — oauth-server revalidates everything). */
export const OAUTH_AUTHORIZE_PATH = '/oauth/authorize';

const PARAM_KEYS = [
  'client_id',
  'redirect_uri',
  'response_type',
  'scope',
  'state',
  'code_challenge',
  'code_challenge_method',
] as const;

export type OAuthAuthorizeParams = Record<(typeof PARAM_KEYS)[number], string>;

export function isOAuthAuthorizeRoute(
  pathname: string = typeof window !== 'undefined' ? window.location.pathname : '',
): boolean {
  return (pathname.replace(/\/$/, '') || '/') === OAUTH_AUTHORIZE_PATH;
}

export function readOAuthAuthorizeParams(search: string): OAuthAuthorizeParams {
  const q = new URLSearchParams(search);
  const out = {} as OAuthAuthorizeParams;
  for (const key of PARAM_KEYS) out[key] = q.get(key) ?? '';
  return out;
}

/** Minimum needed to even attempt consent; server decides validity. */
export function hasRequiredOAuthParams(p: OAuthAuthorizeParams): boolean {
  return Boolean(p.client_id && p.redirect_uri);
}

/** Only follow http(s) URLs returned by the server. */
export function isSafeRedirectUrl(url: unknown): url is string {
  if (typeof url !== 'string') return false;
  try {
    const u = new URL(url);
    return u.protocol === 'https:' || u.protocol === 'http:';
  } catch {
    return false;
  }
}
